export const UseCaseGroupEnum = {
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  SERVICE: 'SERVICE',
  COMMERCE: 'COMMERCE',
  CONTENT: 'CONTENT',
  DATA: 'DATA',
  SMART_CRM: 'SMART_CRM'
};
export const HandledUseCaseGroups = Object.values(UseCaseGroupEnum);
export const useCasesQueryParamKey = 'useCaseGroups';

// TODO [HSoC]: Will be queried from BE as user selects use case
export const FEATURE_LIST = ['Help Desk', 'Customer Success', 'Knowledge Base', 'Feedback Surveys', 'Health Scores', 'SLAs'];